<section class="browser-ntf-panel" [class.mobile]="rwdService.isSmallDevice">
  <button mat-icon-button type="button" class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <header class="panel-header">
    <div class="panel-title">
      <mat-icon>notifications_active</mat-icon>
      <h2>{{ 'browserNtf.panel.title' | loc }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="refresh()" [disabled]="loading" [matTooltip]="'browserNtf.panel.refresh' | loc">
      <mat-icon>refresh</mat-icon>
    </button>
  </header>

  <div class="filters" [formGroup]="filterForm">
    <div class="filter-row">
      <mat-form-field appearance="outline" class="full-width background-white">
        <mat-select formControlName="type" disableOptionCentering>
          <mat-option *ngFor="let option of typeOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width background-white">
        <mat-select formControlName="estateId" disableOptionCentering>
          <mat-option *ngFor="let option of estateOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="search-field full-width background-white">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput formControlName="search" [placeholder]="'browserNtf.panel.searchPlaceholder' | loc" />
    </mat-form-field>

    <div class="toolbar-row">
      <button type="button" class="text-action" (click)="markAllAsRead()" [disabled]="!unreadCount || loading">
        <mat-icon>check_circle_outline</mat-icon>
        <span>{{ 'browserNtf.panel.markAllRead' | loc }}</span>
      </button>

      <app-slide-toggle-input
        formControlName="unreadOnly"
        [padded]="false"
        labelKey="browserNtf.panel.unreadOnly"
      ></app-slide-toggle-input>
    </div>
  </div>

  <div class="loading-row" *ngIf="loading && !notifications.length">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div class="empty-state" *ngIf="!loading && !filteredNotifications.length">
    <mat-icon>notifications_none</mat-icon>
    <span>{{ 'browserNtf.panel.empty' | loc }}</span>
  </div>

  <div class="notification-list" *ngIf="filteredNotifications.length">
    <article
      class="notification-item"
      *ngFor="let vm of filteredNotifications; trackBy: trackByNotification"
      [class.unread]="!vm.notification.displayed"
    >
      <div class="icon-bubble">
        <mat-icon>{{ vm.icon }}</mat-icon>
      </div>

      <div class="notification-content">
        <div class="content-row">
          <div class="message">
            <div class="title-line">
              <span class="category">{{ vm.category }}</span>
              <span class="title-dot"></span>
              <span class="action">{{ vm.action }}</span>
            </div>
            <div class="body">{{ vm.notification.body || vm.notification.title }}</div>
          </div>

          <aside class="meta">
            <div class="estate" *ngIf="vm.estateName">
              <span>{{ vm.estateName }}</span>
              <span class="unread-dot" *ngIf="!vm.notification.displayed"></span>
            </div>
            <div class="time">{{ vm.timeLabel }}</div>
          </aside>
        </div>

        <div class="item-actions">
          <button mat-stroked-button type="button" (click)="toggleDisplayed(vm, $event)">
            {{ !!vm.notification.displayed | locIfElse: 'browserNtf.panel' : 'markUnread' : 'markRead' }}
          </button>

          <button mat-flat-button color="primary" type="button" (click)="openDetails(vm)">
            {{ 'browserNtf.panel.details' | loc }}
          </button>
        </div>
      </div>
    </article>
  </div>

  <div class="load-more" *ngIf="hasMore">
    <button mat-stroked-button type="button" (click)="loadMore()" [disabled]="loading">
      {{ 'browserNtf.panel.loadMore' | loc }}
    </button>
  </div>
</section>
